import React from 'react';

export const Loading = () => {
    return (
        <div className="col-12" align="center">
            <span className="fa fa-spinner fa-pulse fa-4x fa-fw text-primary"></span>
            <h5>Buscando Datos . . .</h5>
        </div>
    );
}

export default Loading;